exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-12a175c8]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #efefef;\n}\n\n/* Mixins */\n.vendor-address .address-info[data-v-12a175c8] {\n  cursor: pointer;\n  padding: 0 8px;\n}", ""]);

